const prodConfig = {
  url: {
    API_URL: 'https://www.webita.com/wp-json/wp/v2',
    FRONTEND_URL: 'https://www.webita.com/templates',
    SETTING_URL: 'https://www.webita.com/wp-json/mwb-gallery-app/v1/settings'
  },
};

export default prodConfig;
